import { array, assign, number, type } from "superstruct";

import { WishlistItemSchema } from "./WishlistItemSchema";
import { WishlistSchema } from "./WishlistSchema";

export const WishlistWithItemsSchema = assign(
    WishlistSchema,
    type({
        items: array(WishlistItemSchema),
        perPage: number(),
        currentOffset: number(),
        totalCount: number(),
    })
);
